import { Star } from 'lucide-react';

export function StarRating({ rating = 5, size = 'sm' }) {
  const sizes = { sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-6 w-6' };
  const s = sizes[size] || sizes.sm;
  return (
    <div className="inline-flex items-center gap-0.5" aria-label={`Note ${rating} sur 5`}>
      {[1,2,3,4,5].map((i) => (
        <Star key={i} className={`${s} ${i <= rating ? 'fill-amber-400 text-amber-400' : 'text-anthracite-200'}`} />
      ))}
    </div>
  );
}
